import React from "react";
import { MapPin, Clock, Phone } from "lucide-react";
import { SITE, whatsappLink } from "@/data/site";

export default function Locations() {
  return (
    <section
      id="locations"
      data-testid="locations-section"
      className="relative bg-brand-bg py-24 lg:py-32 border-t border-brand-border"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-14">
          <div className="text-xs uppercase tracking-[0.3em] text-brand-accent">Pobočky</div>
          <h2 className="mt-4 font-display font-black text-4xl lg:text-6xl leading-[1.05] tracking-tight">
            Najdete nás{" "}
            <span className="italic font-light">na dvou místech v Praze.</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-px bg-brand-border">
          {SITE.locations.map((loc) => (
            <div
              key={loc.key}
              data-testid={`location-card-${loc.key}`}
              className="bg-brand-bg p-10 group hover:bg-brand-surface transition-colors"
            >
              <div className="flex items-start justify-between mb-8">
                <div>
                  <div className="text-xs uppercase tracking-[0.3em] text-brand-muted">
                    Car Spa
                  </div>
                  <h3 className="mt-2 font-display font-black text-3xl lg:text-4xl">
                    {loc.name}
                  </h3>
                </div>
                <div className="w-12 h-12 border border-brand-border flex items-center justify-center text-brand-accent group-hover:border-brand-accent transition-colors">
                  <MapPin size={18} />
                </div>
              </div>

              <div className="space-y-4 text-sm">
                <div className="flex items-start gap-3">
                  <MapPin size={16} className="mt-0.5 text-brand-accent shrink-0" />
                  <span>
                    <span className="block text-white/90">{loc.address}</span>
                    {loc.hint && (
                      <span className="block text-brand-accent text-xs mt-0.5" data-testid={`location-hint-${loc.key}`}>
                        {loc.hint}
                      </span>
                    )}
                  </span>
                </div>
                <div className="flex items-start gap-3">
                  <Clock size={16} className="mt-0.5 text-brand-accent shrink-0" />
                  <span className="text-white/90">{loc.hours}</span>
                </div>
                <div className="flex items-start gap-3">
                  <Phone size={16} className="mt-0.5 text-brand-accent shrink-0" />
                  <a
                    href={`tel:${loc.phone.replace(/\s/g, "")}`}
                    target="_blank"
                    rel="noreferrer"
                    className="text-white/90 hover:text-brand-accent"
                  >
                    {loc.phone}
                  </a>
                </div>
              </div>

              <div className="mt-8 flex flex-wrap gap-3">
                <a
                  href={`https://www.google.com/maps/search/${encodeURIComponent(loc.address)}`}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`map-link-${loc.key}`}
                  className="text-xs uppercase tracking-[0.2em] border border-brand-border px-4 py-2.5 hover:border-brand-accent hover:text-brand-accent transition-all"
                >
                  Navigovat
                </a>
                <a
                  href="#reservation"
                  className="text-xs uppercase tracking-[0.2em] bg-brand-accent text-black font-semibold px-4 py-2.5 hover:bg-brand-accentHover transition-all"
                >
                  Rezervovat
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
